// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see CryptoAllocatePayrollStartEvent
 */
export var CryptoAllocatePayrollStart = function (_a) {
    var currentAllocationBps = _a.currentAllocationBps, state = _a.state;
    return ({
        name: "Crypto AllocatePayroll Start",
        parameters: {
            cdf_entity: "Crypto",
            cdf_action: "AllocatePayroll",
            current_allocation_bps: currentAllocationBps !== undefined && currentAllocationBps !== null ? currentAllocationBps.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            state: state !== undefined && state !== null ? state.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CryptoAllocatePayrollBeginRequestCashCardEvent
 */
export var CryptoAllocatePayrollBeginRequestCashCard = function () { return ({
    name: "Crypto AllocatePayroll BeginRequestCashCard",
    parameters: {
        cdf_entity: "Crypto",
        cdf_action: "AllocatePayroll",
    }
}); };
/**
 * @see CryptoAllocatePayrollBeginActivateCashCardEvent
 */
export var CryptoAllocatePayrollBeginActivateCashCard = function () { return ({
    name: "Crypto AllocatePayroll BeginActivateCashCard",
    parameters: {
        cdf_entity: "Crypto",
        cdf_action: "AllocatePayroll",
    }
}); };
/**
 * @see CryptoAllocatePayrollOpenAllocationPickerEvent
 */
export var CryptoAllocatePayrollOpenAllocationPicker = function (_a) {
    var currentAllocationBps = _a.currentAllocationBps;
    return ({
        name: "Crypto AllocatePayroll OpenAllocationPicker",
        parameters: {
            cdf_entity: "Crypto",
            cdf_action: "AllocatePayroll",
            current_allocation_bps: currentAllocationBps !== undefined && currentAllocationBps !== null ? currentAllocationBps.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CryptoAllocatePayrollOpenCustomAllocationEvent
 */
export var CryptoAllocatePayrollOpenCustomAllocation = function (_a) {
    var currentAllocationBps = _a.currentAllocationBps;
    return ({
        name: "Crypto AllocatePayroll OpenCustomAllocation",
        parameters: {
            cdf_entity: "Crypto",
            cdf_action: "AllocatePayroll",
            current_allocation_bps: currentAllocationBps !== undefined && currentAllocationBps !== null ? currentAllocationBps.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CryptoAllocatePayrollStartPaychecksAllocationFlowEvent
 */
export var CryptoAllocatePayrollStartPaychecksAllocationFlow = function (_a) {
    var alreadyEnrolled = _a.alreadyEnrolled;
    return ({
        name: "Crypto AllocatePayroll StartPaychecksAllocationFlow",
        parameters: {
            cdf_entity: "Crypto",
            cdf_action: "AllocatePayroll",
            already_enrolled: alreadyEnrolled !== undefined && alreadyEnrolled !== null ? alreadyEnrolled.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CryptoAllocatePayrollSetupDirectDepositEvent
 */
export var CryptoAllocatePayrollSetupDirectDeposit = function (_a) {
    var currentAllocationBps = _a.currentAllocationBps;
    return ({
        name: "Crypto AllocatePayroll SetupDirectDeposit",
        parameters: {
            cdf_entity: "Crypto",
            cdf_action: "AllocatePayroll",
            current_allocation_bps: currentAllocationBps !== undefined && currentAllocationBps !== null ? currentAllocationBps.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CryptoAllocatePayrollCompleteEvent
 */
export var CryptoAllocatePayrollComplete = function (_a) {
    var currentAllocationBps = _a.currentAllocationBps, targetAllocationBps = _a.targetAllocationBps;
    return ({
        name: "Crypto AllocatePayroll Complete",
        parameters: {
            cdf_entity: "Crypto",
            cdf_action: "AllocatePayroll",
            current_allocation_bps: currentAllocationBps !== undefined && currentAllocationBps !== null ? currentAllocationBps.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            target_allocation_bps: targetAllocationBps !== undefined && targetAllocationBps !== null ? targetAllocationBps.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CryptoDepositStartEvent
 */
export var CryptoDepositStart = function (_a) {
    var source = _a.source;
    return ({
        name: "Crypto Deposit Start",
        parameters: {
            cdf_entity: "Crypto",
            cdf_action: "Deposit",
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CryptoDepositCreateInvoiceEvent
 */
export var CryptoDepositCreateInvoice = function (_a) {
    var amountInSats = _a.amountInSats, noteIncluded = _a.noteIncluded;
    return ({
        name: "Crypto Deposit CreateInvoice",
        parameters: {
            cdf_entity: "Crypto",
            cdf_action: "Deposit",
            amount_in_sats: amountInSats !== undefined && amountInSats !== null ? amountInSats.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            note_included: noteIncluded !== undefined && noteIncluded !== null ? noteIncluded.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CryptoDepositShareInvoiceEvent
 */
export var CryptoDepositShareInvoice = function (_a) {
    var shareOption = _a.shareOption, completed = _a.completed;
    return ({
        name: "Crypto Deposit ShareInvoice",
        parameters: {
            cdf_entity: "Crypto",
            cdf_action: "Deposit",
            share_option: shareOption !== undefined && shareOption !== null ? shareOption.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            completed: completed !== undefined && completed !== null ? completed.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CryptoDepositRefreshInvoiceEvent
 */
export var CryptoDepositRefreshInvoice = function (_a) {
    var invoiceIdsMatch = _a.invoiceIdsMatch;
    return ({
        name: "Crypto Deposit RefreshInvoice",
        parameters: {
            cdf_entity: "Crypto",
            cdf_action: "Deposit",
            invoice_ids_match: invoiceIdsMatch !== undefined && invoiceIdsMatch !== null ? invoiceIdsMatch.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CryptoDepositCopyEvent
 */
export var CryptoDepositCopy = function (_a) {
    var contentType = _a.contentType, source = _a.source;
    return ({
        name: "Crypto Deposit Copy",
        parameters: {
            cdf_entity: "Crypto",
            cdf_action: "Deposit",
            content_type: contentType !== undefined && contentType !== null ? contentType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CryptoSpendGrantLocationPermissionEvent
 */
export var CryptoSpendGrantLocationPermission = function (_a) {
    var androidLocationAuthorizationStatus = _a.androidLocationAuthorizationStatus, iosLocationAuthorizationStatus = _a.iosLocationAuthorizationStatus, iosPreciseLocationEnabled = _a.iosPreciseLocationEnabled;
    return ({
        name: "Crypto Spend GrantLocationPermission",
        parameters: {
            cdf_entity: "Crypto",
            cdf_action: "Spend",
            android_location_authorization_status: androidLocationAuthorizationStatus !== undefined && androidLocationAuthorizationStatus !== null ? androidLocationAuthorizationStatus.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            ios_location_authorization_status: iosLocationAuthorizationStatus !== undefined && iosLocationAuthorizationStatus !== null ? iosLocationAuthorizationStatus.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            ios_precise_location_enabled: iosPreciseLocationEnabled !== undefined && iosPreciseLocationEnabled !== null ? iosPreciseLocationEnabled.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CryptoSpendSearchAddressEvent
 */
export var CryptoSpendSearchAddress = function () { return ({
    name: "Crypto Spend SearchAddress",
    parameters: {
        cdf_entity: "Crypto",
        cdf_action: "Spend",
    }
}); };
/**
 * @see CryptoSpendSelectAddressEvent
 */
export var CryptoSpendSelectAddress = function (_a) {
    var recentAddress = _a.recentAddress;
    return ({
        name: "Crypto Spend SelectAddress",
        parameters: {
            cdf_entity: "Crypto",
            cdf_action: "Spend",
            recent_address: recentAddress !== undefined && recentAddress !== null ? recentAddress.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CryptoSpendOnboardEvent
 */
export var CryptoSpendOnboard = function () { return ({
    name: "Crypto Spend Onboard",
    parameters: {
        cdf_entity: "Crypto",
        cdf_action: "Spend",
    }
}); };
/**
 * @see CryptoSpendApplyFilterEvent
 */
export var CryptoSpendApplyFilter = function (_a) {
    var squareOnly = _a.squareOnly;
    return ({
        name: "Crypto Spend ApplyFilter",
        parameters: {
            cdf_entity: "Crypto",
            cdf_action: "Spend",
            square_only: squareOnly !== undefined && squareOnly !== null ? squareOnly.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CryptoSpendPayFromMapEvent
 */
export var CryptoSpendPayFromMap = function () { return ({
    name: "Crypto Spend PayFromMap",
    parameters: {
        cdf_entity: "Crypto",
        cdf_action: "Spend",
    }
}); };
/**
 * @see CryptoTradeStartEvent
 */
export var CryptoTradeStart = function (_a) {
    var side = _a.side, targetAsset = _a.targetAsset, sourceAsset = _a.sourceAsset;
    return ({
        name: "Crypto Trade Start",
        parameters: {
            cdf_entity: "Crypto",
            cdf_action: "Trade",
            side: side !== undefined && side !== null ? side.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            target_asset: targetAsset !== undefined && targetAsset !== null ? targetAsset.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            source_asset: sourceAsset !== undefined && sourceAsset !== null ? sourceAsset.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CryptoTradeSelectCustomAmountEvent
 */
export var CryptoTradeSelectCustomAmount = function (_a) {
    var side = _a.side, targetAsset = _a.targetAsset, sourceAsset = _a.sourceAsset;
    return ({
        name: "Crypto Trade SelectCustomAmount",
        parameters: {
            cdf_entity: "Crypto",
            cdf_action: "Trade",
            side: side !== undefined && side !== null ? side.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            target_asset: targetAsset !== undefined && targetAsset !== null ? targetAsset.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            source_asset: sourceAsset !== undefined && sourceAsset !== null ? sourceAsset.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CryptoTradeChangeOrderTypeEvent
 */
export var CryptoTradeChangeOrderType = function (_a) {
    var side = _a.side, targetAsset = _a.targetAsset, sourceAsset = _a.sourceAsset;
    return ({
        name: "Crypto Trade ChangeOrderType",
        parameters: {
            cdf_entity: "Crypto",
            cdf_action: "Trade",
            side: side !== undefined && side !== null ? side.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            target_asset: targetAsset !== undefined && targetAsset !== null ? targetAsset.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            source_asset: sourceAsset !== undefined && sourceAsset !== null ? sourceAsset.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CryptoTradeSelectAutoInvestEvent
 */
export var CryptoTradeSelectAutoInvest = function (_a) {
    var targetAsset = _a.targetAsset, sourceAsset = _a.sourceAsset;
    return ({
        name: "Crypto Trade SelectAutoInvest",
        parameters: {
            cdf_entity: "Crypto",
            cdf_action: "Trade",
            target_asset: targetAsset !== undefined && targetAsset !== null ? targetAsset.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            source_asset: sourceAsset !== undefined && sourceAsset !== null ? sourceAsset.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CryptoTradeSetAutoInvestEvent
 */
export var CryptoTradeSetAutoInvest = function (_a) {
    var targetAsset = _a.targetAsset, sourceAsset = _a.sourceAsset;
    return ({
        name: "Crypto Trade SetAutoInvest",
        parameters: {
            cdf_entity: "Crypto",
            cdf_action: "Trade",
            target_asset: targetAsset !== undefined && targetAsset !== null ? targetAsset.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            source_asset: sourceAsset !== undefined && sourceAsset !== null ? sourceAsset.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CryptoTradeSelectLimitOrderEvent
 */
export var CryptoTradeSelectLimitOrder = function (_a) {
    var side = _a.side, targetAsset = _a.targetAsset, sourceAsset = _a.sourceAsset;
    return ({
        name: "Crypto Trade SelectLimitOrder",
        parameters: {
            cdf_entity: "Crypto",
            cdf_action: "Trade",
            side: side !== undefined && side !== null ? side.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            target_asset: targetAsset !== undefined && targetAsset !== null ? targetAsset.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            source_asset: sourceAsset !== undefined && sourceAsset !== null ? sourceAsset.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CryptoTradeSetLimitOrderEvent
 */
export var CryptoTradeSetLimitOrder = function (_a) {
    var side = _a.side, targetAsset = _a.targetAsset, sourceAsset = _a.sourceAsset;
    return ({
        name: "Crypto Trade SetLimitOrder",
        parameters: {
            cdf_entity: "Crypto",
            cdf_action: "Trade",
            side: side !== undefined && side !== null ? side.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            target_asset: targetAsset !== undefined && targetAsset !== null ? targetAsset.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            source_asset: sourceAsset !== undefined && sourceAsset !== null ? sourceAsset.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CryptoTradeCompleteEvent
 */
export var CryptoTradeComplete = function (_a) {
    var orderType = _a.orderType, side = _a.side, targetAsset = _a.targetAsset, sourceAsset = _a.sourceAsset;
    return ({
        name: "Crypto Trade Complete",
        parameters: {
            cdf_entity: "Crypto",
            cdf_action: "Trade",
            order_type: orderType !== undefined && orderType !== null ? orderType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            side: side !== undefined && side !== null ? side.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            target_asset: targetAsset !== undefined && targetAsset !== null ? targetAsset.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            source_asset: sourceAsset !== undefined && sourceAsset !== null ? sourceAsset.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CryptoTradeFirstTimeBuyEvent
 */
export var CryptoTradeFirstTimeBuy = function () { return ({
    name: "Crypto Trade FirstTimeBuy",
    parameters: {
        cdf_entity: "Crypto",
        cdf_action: "Trade",
    }
}); };
/**
 * @see CryptoTradeCloseEvent
 */
export var CryptoTradeClose = function () { return ({
    name: "Crypto Trade Close",
    parameters: {
        cdf_entity: "Crypto",
        cdf_action: "Trade",
    }
}); };
/**
 * @see CryptoSendStartEvent
 */
export var CryptoSendStart = function (_a) {
    var source = _a.source;
    return ({
        name: "Crypto Send Start",
        parameters: {
            cdf_entity: "Crypto",
            cdf_action: "Send",
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CryptoSendOpenQrScannerEvent
 */
export var CryptoSendOpenQrScanner = function (_a) {
    var source = _a.source;
    return ({
        name: "Crypto Send OpenQrScanner",
        parameters: {
            cdf_entity: "Crypto",
            cdf_action: "Send",
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CryptoSendScanQrEvent
 */
export var CryptoSendScanQr = function (_a) {
    var networkType = _a.networkType, contentType = _a.contentType, source = _a.source;
    return ({
        name: "Crypto Send ScanQr",
        parameters: {
            cdf_entity: "Crypto",
            cdf_action: "Send",
            network_type: networkType !== undefined && networkType !== null ? networkType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            content_type: contentType !== undefined && contentType !== null ? contentType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CryptoSendPasteAddressEvent
 */
export var CryptoSendPasteAddress = function (_a) {
    var networkType = _a.networkType, contentType = _a.contentType;
    return ({
        name: "Crypto Send PasteAddress",
        parameters: {
            cdf_entity: "Crypto",
            cdf_action: "Send",
            network_type: networkType !== undefined && networkType !== null ? networkType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            content_type: contentType !== undefined && contentType !== null ? contentType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CryptoSendSubmitRecipientEvent
 */
export var CryptoSendSubmitRecipient = function () { return ({
    name: "Crypto Send SubmitRecipient",
    parameters: {
        cdf_entity: "Crypto",
        cdf_action: "Send",
    }
}); };
/**
 * @see CryptoSendSubmitAmountEvent
 */
export var CryptoSendSubmitAmount = function (_a) {
    var source = _a.source;
    return ({
        name: "Crypto Send SubmitAmount",
        parameters: {
            cdf_entity: "Crypto",
            cdf_action: "Send",
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CryptoSendCompleteEvent
 */
export var CryptoSendComplete = function (_a) {
    var blockerFlowToken = _a.blockerFlowToken, networkType = _a.networkType, contentType = _a.contentType, result = _a.result, isSigned = _a.isSigned;
    return ({
        name: "Crypto Send Complete",
        parameters: {
            cdf_entity: "Crypto",
            cdf_action: "Send",
            blocker_flow_token: blockerFlowToken !== undefined && blockerFlowToken !== null ? blockerFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            network_type: networkType !== undefined && networkType !== null ? networkType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            content_type: contentType !== undefined && contentType !== null ? contentType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            result: result !== undefined && result !== null ? result.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_signed: isSigned !== undefined && isSigned !== null ? isSigned.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CryptoSendCloseEvent
 */
export var CryptoSendClose = function () { return ({
    name: "Crypto Send Close",
    parameters: {
        cdf_entity: "Crypto",
        cdf_action: "Send",
    }
}); };
/**
 * @see CryptoLearnStartEvent
 */
export var CryptoLearnStart = function (_a) {
    var contentType = _a.contentType, identifier = _a.identifier, loadDurationMs = _a.loadDurationMs, loadStatus = _a.loadStatus;
    return ({
        name: "Crypto Learn Start",
        parameters: {
            cdf_entity: "Crypto",
            cdf_action: "Learn",
            content_type: contentType !== undefined && contentType !== null ? contentType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            identifier: identifier !== undefined && identifier !== null ? identifier.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            load_duration_ms: loadDurationMs !== undefined && loadDurationMs !== null ? loadDurationMs.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            load_status: loadStatus !== undefined && loadStatus !== null ? loadStatus.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CryptoLearnCompleteEvent
 */
export var CryptoLearnComplete = function (_a) {
    var viewedAllContent = _a.viewedAllContent, lastViewedIndex = _a.lastViewedIndex, exitSource = _a.exitSource, contentType = _a.contentType, identifier = _a.identifier;
    return ({
        name: "Crypto Learn Complete",
        parameters: {
            cdf_entity: "Crypto",
            cdf_action: "Learn",
            viewed_all_content: viewedAllContent !== undefined && viewedAllContent !== null ? viewedAllContent.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            last_viewed_index: lastViewedIndex !== undefined && lastViewedIndex !== null ? lastViewedIndex.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            exit_source: exitSource !== undefined && exitSource !== null ? exitSource.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            content_type: contentType !== undefined && contentType !== null ? contentType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            identifier: identifier !== undefined && identifier !== null ? identifier.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CryptoInteractCloseEvent
 */
export var CryptoInteractClose = function () { return ({
    name: "Crypto Interact Close",
    parameters: {
        cdf_entity: "Crypto",
        cdf_action: "Interact",
    }
}); };
/**
 * @see CryptoInteractGraphScrubEvent
 */
export var CryptoInteractGraphScrub = function () { return ({
    name: "Crypto Interact GraphScrub",
    parameters: {
        cdf_entity: "Crypto",
        cdf_action: "Interact",
    }
}); };
/**
 * @see CryptoInteractSelectDateRangeEvent
 */
export var CryptoInteractSelectDateRange = function (_a) {
    var dateRange = _a.dateRange;
    return ({
        name: "Crypto Interact SelectDateRange",
        parameters: {
            cdf_entity: "Crypto",
            cdf_action: "Interact",
            date_range: dateRange !== undefined && dateRange !== null ? dateRange.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CryptoInteractOpenTransferEvent
 */
export var CryptoInteractOpenTransfer = function () { return ({
    name: "Crypto Interact OpenTransfer",
    parameters: {
        cdf_entity: "Crypto",
        cdf_action: "Interact",
    }
}); };
/**
 * @see CryptoInteractCloseTransferEvent
 */
export var CryptoInteractCloseTransfer = function () { return ({
    name: "Crypto Interact CloseTransfer",
    parameters: {
        cdf_entity: "Crypto",
        cdf_action: "Interact",
    }
}); };
/**
 * @see CryptoChangeStartEvent
 */
export var CryptoChangeStart = function (_a) {
    var setting = _a.setting;
    return ({
        name: "Crypto Change Start",
        parameters: {
            cdf_entity: "Crypto",
            cdf_action: "Change",
            setting: setting !== undefined && setting !== null ? setting.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CryptoStackStartEvent
 */
export var CryptoStackStart = function (_a) {
    var type = _a.type, entryPoint = _a.entryPoint, enabled = _a.enabled;
    return ({
        name: "Crypto Stack Start",
        parameters: {
            cdf_entity: "Crypto",
            cdf_action: "Stack",
            type: type !== undefined && type !== null ? type.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            entry_point: entryPoint !== undefined && entryPoint !== null ? entryPoint.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            enabled: enabled !== undefined && enabled !== null ? enabled.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CryptoTimeoutPerformanceDataRefreshTimeoutEvent
 */
export var CryptoTimeoutPerformanceDataRefreshTimeout = function () { return ({
    name: "Crypto Timeout PerformanceDataRefreshTimeout",
    parameters: {
        cdf_entity: "Crypto",
        cdf_action: "Timeout",
    }
}); };
/**
 * @see CryptoInteractPerformanceDetailsEvent
 */
export var CryptoInteractPerformanceDetails = function () { return ({
    name: "Crypto InteractPerformance Details",
    parameters: {
        cdf_entity: "Crypto",
        cdf_action: "InteractPerformance",
    }
}); };
/**
 * @see CryptoInteractPerformanceDetailsInfoItemEvent
 */
export var CryptoInteractPerformanceDetailsInfoItem = function (_a) {
    var type = _a.type;
    return ({
        name: "Crypto InteractPerformance DetailsInfoItem",
        parameters: {
            cdf_entity: "Crypto",
            cdf_action: "InteractPerformance",
            type: type !== undefined && type !== null ? type.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CryptoInitiatePartnerActionStartEvent
 */
export var CryptoInitiatePartnerActionStart = function (_a) {
    var action = _a.action, partner = _a.partner;
    return ({
        name: "Crypto InitiatePartnerAction Start",
        parameters: {
            cdf_entity: "Crypto",
            cdf_action: "InitiatePartnerAction",
            action: action !== undefined && action !== null ? action.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            partner: partner !== undefined && partner !== null ? partner.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CryptoMeasureParserPerformanceRecordEvent
 */
export var CryptoMeasureParserPerformanceRecord = function (_a) {
    var timeMs = _a.timeMs;
    return ({
        name: "Crypto MeasureParserPerformance Record",
        parameters: {
            cdf_entity: "Crypto",
            cdf_action: "MeasureParserPerformance",
            time_ms: timeMs !== undefined && timeMs !== null ? timeMs.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
